const getAccessToken = async (instance) => {
  let account = instance.getActiveAccount();
  const allAccounts = instance.getAllAccounts();

  if (!account && allAccounts.length > 0) {
    account = allAccounts[0];
    instance.setActiveAccount(account);
  }

  if (!account) throw new Error("No active account");

  try {
    const response = await instance.acquireTokenSilent({
      account,
      scopes: ['User.Read'],
    });
    return response.accessToken;
  } catch (error) {
    console.error("Silent token acquisition failed:", error);
    throw error;
  }
};

export default getAccessToken;